import { BaseSelectors } from '@makemydeal/dr-activities-common';
import type { AdditionalSelectors, TradeInState } from '../types';
import { TRADE_SUMMARY, TRADE_VEHICLE_INFO } from '@makemydeal/dr-activities-tradein';

export const getTradeInValue = (state: TradeInState): number => {
    return (state.tradeInComponent?.value || 0) - getTradeInAmountOwed(state);
};

export const getTradeInAmountOwed = (state: TradeInState): number => {
    return state.tradeInComponent?.amountOwed || 0;
};

export const isTradeInCompleted = (state: TradeInState): boolean => {
    return state.tradeInComponent?.isCompleted || false;
};

// True only for a trade-in rehydrated from the offer (has a value) — i.e. already saved.
export const hasSavedTradeIn = (state: TradeInState): boolean => {
    return (state.tradeInComponent?.value ?? 0) > 0;
};

// Completed trades re-enter on the Trade Summary page; otherwise start at Vehicle Info.
export const getTradeInBaseRoute = (isCompleted = false): string => (isCompleted ? TRADE_SUMMARY : TRADE_VEHICLE_INFO);

export class Selectors extends BaseSelectors {
    constructor(public sliceName: string, public additionalSelectors: AdditionalSelectors) {
        super(sliceName);
    }
}
